import AuthValidation from "../../validation/AuthValidation";
import { IRequestModel, HttpMethod, ValidationResponse } from "../../IRequestModel";

export class AddServerRequest implements IRequestModel {

    constructor(serverId: string, grantToken: string) {
        this.server_id = serverId;
        this.grant_token = grantToken;
    }

    uri: string = "server/add-server";
    method: HttpMethod = HttpMethod.POST;

    server_id: string;
    grant_token: string;

    isValid(): ValidationResponse {
        return ValidationResponse.Success();
    }
}